/**
 * Traduce errores del API (`ConsoleApiError`, ver `src/api/http.ts`) a un mensaje en español
 * seguro para mostrar en la interfaz. Nunca expone `stack` ni el objeto crudo (docs/FASE-1.md §6:
 * "Errores en el formato ErrorResponse se muestran con su message en español; nunca se pinta un
 * stack ni un objeto crudo").
 */

import { ConsoleApiError } from "../api/http";

const FALLBACK_MESSAGE = "Ocurrió un error inesperado. Intenta de nuevo.";

/** Mensaje listo para mostrar al operador. Solo `ConsoleApiError` trae un mensaje de confianza. */
export function toDisplayMessage(error: unknown): string {
  if (error instanceof ConsoleApiError) {
    return error.message;
  }
  return FALLBACK_MESSAGE;
}

/** true si el error es un `ConsoleApiError` con el `code` dado (para ramas puntuales de la UI). */
export function hasErrorCode(error: unknown, code: string): boolean {
  return error instanceof ConsoleApiError && error.code === code;
}
